import { render } from "./TicketInformation.vue?vue&type=template&id=1ba56772&scoped=true"
import script from "./TicketInformation.vue?vue&type=script&lang=js"
export * from "./TicketInformation.vue?vue&type=script&lang=js"

import "./TicketInformation.vue?vue&type=style&index=0&id=1ba56772&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ba56772"

export default script